import {

  getGeolocationPlatform,

  isStandalonePwa,

  type GeolocationPlatform,

} from "@/src/modules/core/lib/geolocation-platform";



export type CameraFacingMode = "environment" | "user";



export type CameraEnvironmentDiagnostics = {

  secureContext: boolean;

  hasGetUserMedia: boolean;

  permissionsPolicyAllowsCamera: boolean;

  userActivationActive: boolean;

  platform: GeolocationPlatform;

  standalonePwa: boolean;

};



/** Telemetry only — never used to skip getUserMedia. */

export function getCameraEnvironmentDiagnostics(): CameraEnvironmentDiagnostics {

  const permissionsPolicyExplicit =
    typeof document !== "undefined"
      ? (
          document as Document & {
            permissionsPolicy?: {allowsFeature: (feature: string) => boolean};
          }
        ).permissionsPolicy?.allowsFeature?.("camera")
      : undefined;



  return {

    secureContext: typeof window !== "undefined" && window.isSecureContext,

    hasGetUserMedia: Boolean(navigator?.mediaDevices?.getUserMedia),

    permissionsPolicyAllowsCamera: permissionsPolicyExplicit ?? true,

    userActivationActive: navigator.userActivation?.isActive ?? false,

    platform: getGeolocationPlatform(),

    standalonePwa: isStandalonePwa(),

  };

}



function getCameraVideoConstraints(facingMode: CameraFacingMode): MediaStreamConstraints {

  return {

    video: {

      facingMode: {ideal: facingMode},

      width: {ideal: 1920},

      height: {ideal: 1080},

    },

    audio: false,

  };

}



/**

 * Call synchronously from pointerdown/click on the Camera control.

 * Prefers rear camera; falls back to `{ video: true }` on OverconstrainedError.

 */

export function requestCameraVideoStream(

  facingMode: CameraFacingMode = "environment",

): Promise<MediaStream> | null {

  const getUserMedia = navigator.mediaDevices?.getUserMedia?.bind(navigator.mediaDevices);

  if (!getUserMedia) {

    return null;

  }



  const request = (constraints: MediaStreamConstraints) => getUserMedia(constraints);



  return request(getCameraVideoConstraints(facingMode)).catch((error: unknown) => {

    const name =

      error instanceof DOMException

        ? error.name

        : typeof error === "object" && error !== null && "name" in error

          ? String((error as {name: unknown}).name)

          : undefined;



    if (name === "OverconstrainedError" && facingMode === "environment") {

      return request({video: true, audio: false});

    }



    throw error;

  });

}

import {turnOffCameraTorch} from "@/src/modules/core/lib/camera-flash";

/** Detach preview and stop all tracks so the OS releases the camera (indicator/LED off). */
export function releaseMediaStream(
  stream: MediaStream | null | undefined,
  video?: HTMLVideoElement | null,
): void {
  if (video) {
    video.srcObject = null;
  }
  if (!stream) {
    return;
  }
  void turnOffCameraTorch(stream);
  for (const track of stream.getTracks()) {
    if (track.readyState !== "ended") {
      track.stop();
    }
  }
}
